import React, { Component } from 'react';

import { ToggleButton } from 'react-bootstrap';

export default class SchedulerRadioButton extends Component {
  render() {
    return <ToggleButton {...this.props} className="scheduler_radio" />;
  }
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/SchedulerRadioButton/SchedulerRadioButton.js